export enum MenuItemName {
  General = 'General',
  ExperiencesAndRooms = 'Activities & Rooms',
  Limitations = 'Limitations',
  Copywriting = 'Copywriting',
  Disclaimer = 'Disclaimer',
  Medias = 'Medias',
}
